export const DEFAULT_LOCALE = 'en-US'
export const SUPPORTED_LOCALES = ['en-US']
